export interface Category {
  id: string;
  nameKey: string;
  href: string;
  icon: string;
  image: string;
}

export const MAIN_SITE_URL = 'https://kaspreadsheet.com';

export const categories: Category[] = [
  {
    id: 'shoes',
    nameKey: 'cat.shoes',
    href: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20crisp%20white%20low%20top%20sneakers%20with%20subtle%20sage%20green%20accents%20standing%20on%20a%20soft%20cream%20studio%20surface%2C%20clean%20minimal%20product%20photography%2C%20soft%20diffused%20daylight%2C%20gentle%20realistic%20shadow%2C%20fresh%20editorial%20streetwear%20aesthetic%2C%20crisp%20fabric%20detail%2C%20high%20resolution&width=600&height=600&seq=usfans-cat-shoes-01&orientation=squarish',
  },
  {
    id: 'hoodies',
    nameKey: 'cat.hoodies',
    href: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20soft%20sage%20green%20hoodie%20sweater%20with%20drawstrings%20resting%20on%20a%20clean%20cream%20linen%20surface%2C%20minimal%20flat%20lay%20product%20photography%2C%20soft%20natural%20daylight%2C%20subtle%20fabric%20texture%20and%20gentle%20shadows%2C%20calm%20fresh%20editorial%20aesthetic%2C%20high%20detail&width=600&height=600&seq=usfans-cat-hoodies-02&orientation=squarish',
  },
  {
    id: 'tshirts',
    nameKey: 'cat.tshirts',
    href: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=A%20plain%20cream%20cotton%20t-shirt%20neatly%20folded%20on%20a%20light%20neutral%20surface%20with%20soft%20diffused%20shadows%2C%20minimal%20clean%20product%20photography%2C%20airy%20bright%20daylight%2C%20smooth%20fabric%20texture%2C%20fresh%20editorial%20style%2C%20high%20resolution%20detail&width=600&height=600&seq=usfans-cat-tshirts-03&orientation=squarish',
  },
  {
    id: 'jackets',
    nameKey: 'cat.jackets',
    href: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-t-shirt-2-line',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20beige%20bomber%20jacket%20hanging%20on%20a%20light%20wooden%20hanger%20against%20a%20soft%20cream%20wall%2C%20minimal%20clean%20product%20photography%2C%20soft%20natural%20window%20light%2C%20subtle%20shadows%2C%20premium%20relaxed%20editorial%20aesthetic%2C%20detailed%20stitching%2C%20high%20resolution&width=600&height=600&seq=usfans-cat-jackets-04&orientation=squarish',
  },
  {
    id: 'pants',
    nameKey: 'cat.pants',
    href: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-scissors-line',
    image: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20neatly%20folded%20beige%20chino%20pants%20with%20visible%20cuffs%20on%20a%20clean%20light%20surface%2C%20minimal%20product%20photography%2C%20soft%20diffused%20daylight%2C%20gentle%20fabric%20folds%20and%20subtle%20shadow%2C%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=usfans-cat-pants-05&orientation=squarish',
  },
  {
    id: 'headwear',
    nameKey: 'cat.headwear',
    href: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-vip-crown-line',
    image: 'https://readdy.ai/api/search-image?query=A%20classic%20sage%20green%20baseball%20cap%20with%20a%20curved%20brim%20placed%20on%20a%20clean%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20gentle%20realistic%20shadow%2C%20fresh%20editorial%20streetwear%20aesthetic%2C%20embroidered%20fabric%20detail%2C%20high%20resolution&width=600&height=600&seq=usfans-cat-headwear-06&orientation=squarish',
  },
  {
    id: 'sets',
    nameKey: 'cat.sets',
    href: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=A%20coordinated%20matching%20streetwear%20outfit%20set%20of%20a%20hoodie%20and%20sweatpants%20laid%20flat%20together%20on%20a%20soft%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20natural%20daylight%2C%20clean%20harmonious%20composition%2C%20subtle%20fabric%20texture%2C%20fresh%20editorial%20style%2C%20high%20detail&width=600&height=600&seq=usfans-cat-sets-07&orientation=squarish',
  },
  {
    id: 'underwear',
    nameKey: 'cat.underwear',
    href: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20soft%20cotton%20underwear%20garments%20in%20neutral%20beige%20and%20white%20tones%20arranged%20on%20a%20clean%20light%20surface%2C%20minimal%20product%20photography%2C%20soft%20diffused%20lighting%2C%20subtle%20shadows%2C%20fresh%20clean%20editorial%20style%2C%20high%20resolution%20detail&width=600&height=600&seq=usfans-cat-underwear-08&orientation=squarish',
  },
  {
    id: 'jersey',
    nameKey: 'cat.jersey',
    href: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
    image: 'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20sports%20jersey%20in%20white%20and%20sage%20green%20team%20colors%20with%20subtle%20striped%20accents%20on%20a%20soft%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20studio%20light%2C%20crisp%20fabric%20detail%2C%20clean%20editorial%20aesthetic%2C%20high%20resolution&width=600&height=600&seq=usfans-cat-jersey-09&orientation=squarish',
  },
  {
    id: 'accessories',
    nameKey: 'cat.accessories',
    href: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-gift-line',
    image: 'https://readdy.ai/api/search-image?query=A%20curated%20collection%20of%20minimal%20fashion%20accessories%20including%20a%20wristwatch%2C%20sunglasses%20and%20a%20cap%20arranged%20neatly%20on%20a%20soft%20cream%20surface%2C%20clean%20product%20photography%2C%20soft%20natural%20daylight%2C%20airy%20editorial%20composition%2C%20subtle%20shadows%2C%20high%20detail&width=600&height=600&seq=usfans-cat-accessories-10&orientation=squarish',
  },
  {
    id: 'bags',
    nameKey: 'cat.bags',
    href: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-handbag-line',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20beige%20canvas%20tote%20bag%20standing%20upright%20on%20a%20clean%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20natural%20daylight%2C%20gentle%20realistic%20shadow%2C%20subtle%20canvas%20texture%20and%20leather%20handles%2C%20fresh%20editorial%20aesthetic%2C%20high%20resolution&width=600&height=600&seq=usfans-cat-bags-11&orientation=squarish',
  },
  {
    id: 'belts',
    nameKey: 'cat.belts',
    href: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-wallet-line',
    image: 'https://readdy.ai/api/search-image?query=A%20neatly%20rolled%20brown%20leather%20belt%20with%20a%20simple%20metal%20buckle%20placed%20on%20a%20clean%20light%20neutral%20surface%2C%20minimal%20product%20photography%2C%20soft%20diffused%20daylight%2C%20subtle%20leather%20grain%20texture%2C%20premium%20editorial%20style%2C%20high%20resolution%20detail&width=600&height=600&seq=usfans-cat-belts-12&orientation=squarish',
  },
  {
    id: 'perfumes',
    nameKey: 'cat.perfumes',
    href: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=A%20minimal%20glass%20perfume%20bottle%20with%20soft%20amber%20liquid%20and%20a%20simple%20cap%20on%20a%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20subtle%20reflections%20and%20gentle%20shadow%2C%20fresh%20premium%20editorial%20aesthetic%2C%20high%20resolution%20detail&width=600&height=600&seq=usfans-cat-perfumes-13&orientation=squarish',
  },
  {
    id: 'other',
    nameKey: 'cat.other',
    href: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-archive-line',
    image: 'https://readdy.ai/api/search-image?query=A%20neat%20flat%20lay%20of%20assorted%20streetwear%20accessories%20and%20small%20lifestyle%20items%20including%20a%20cardholder%2C%20keychain%20and%20sunglasses%20arranged%20on%20a%20soft%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20daylight%2C%20clean%20airy%20composition%2C%20high%20detail&width=600&height=600&seq=usfans-cat-other-14&orientation=squarish',
  },
];